import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { ControlValueAccessor, FormControl, FormGroup, NG_VALUE_ACCESSOR, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import {Subscription} from 'rxjs';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';

@Component({
    selector: 'app-date-time',
    templateUrl: './date-time.component.html',
    styleUrls: ['./date-time.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: DateTimeComponent
        }
    ],
    imports: [FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatSelect, MatOption]
})
export class DateTimeComponent implements OnInit, OnDestroy, ControlValueAccessor {
    private datePipe = inject(DatePipe);



    @Input() set minutesPrecision(minutesPrecision: number) {
        this.minutes = this.getMinutes(minutesPrecision);
    }

    @Input() required?: boolean;

    onChangeSubs: Subscription[] = [];

    onTouched = () => {
    };
    touched = false;
    disabled?: boolean;

    hours: string[] = Array.from(Array(24).keys()).map(hour => this.formatNumber(hour));
    minutes: string[];

    form = new FormGroup(
        {
            date: new FormControl<string|null>(null),
            hour: new FormControl<string>('00'),
            minute: new FormControl<string>('00'),
        }
    );


    constructor() {
        this.minutes = this.getMinutes(1);
    }

    ngOnInit(): void {
    }

    ngOnDestroy() {
        for (const sub of this.onChangeSubs) {
            sub.unsubscribe();
        }
    }

    registerOnChange(fn: any): void {
        const sub = this.form.valueChanges.subscribe(
            () => {
                const strOutput = this.form.value.date + 'T' + this.form.value.hour + ':' + this.form.value.minute;
                fn(strOutput);
            }
        );
        this.onChangeSubs.push(sub);
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        if (isDisabled) {
            this.form.disable();
        } else {
            this.form.enable();
        }
    }

    writeValue(datetime: string | Date | null): void {
        this.form.setValue(
            {
                date: datetime ? this.datePipe.transform(datetime, 'yyyy-MM-dd') : null,
                hour: datetime ? this.datePipe.transform(datetime, 'HH') : '00',
                minute: datetime ? this.datePipe.transform(datetime, 'mm') : '00',
            },
            {emitEvent: false}
        );
    }

    markAsTouched() {
        if (!this.touched) {
            this.onTouched();
            this.touched = true;
        }
    }

    private getMinutes(precision: number): string[] {
        if (precision <= 0 || precision > 60) {
            throw new Error('DateTimeComponent : precision must be a positive integer between 1 and 60');
        }

        const nbItems = 60 / precision;

        if (!Number.isInteger(nbItems)) {
            throw new Error('DateTimeComponent : ' + precision + ' is not a valid precision because it results in a non-integer number of choices.');
        }

        const minutes = [];
        for (let i = 0; i < nbItems; i++) {
            minutes.push(this.formatNumber(i * precision));
        }
        return minutes;
    }

    private formatNumber(number: number): string {
        return number < 10 ? '0' + number : number.toString(10);
    }
}
